import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import * as StatusManagerActions from '../../../actions/StatusManagerActions';

class Forbidden extends React.Component {
  componentWillMount() {
    this.props.action.showManager();
  }

  render() {
    return (
      <div className="page">
        <div className="page-content container-fluid text-center">
          <div style={{ paddingTop: '80px' }}>
            <h1 style={{ fontSize: '72px', color: '#e74c3c', fontWeight: 'bold' }}>403</h1>
            <h3 style={{ marginTop: '20px', marginBottom: '10px' }}>Acesso Negado</h3>
            <p style={{ fontSize: '16px', marginTop: '20px', color: '#555' }}>
              Você não tem permissão para acessar esta página.
            </p>
            <p style={{ color: '#7e8e9f', fontSize: '14px' }}>
              Se você acredita que deveria ter acesso, entre em contato com o administrador.
            </p>
            <div style={{ marginTop: '40px' }}>
              <Link to="/manager/dashboard" className="btn btn-primary">
                <i className="fa fa-home" /> Voltar ao Dashboard
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    action: bindActionCreators(StatusManagerActions, dispatch)
  };
}

export default withRouter(connect(null, mapDispatchToProps)(Forbidden));
